/* eslint-disable jsx-a11y/click-events-have-key-events */
import type { HTMLAttributes } from 'react';
import { memo } from 'react';
import Bar from '../bar/Bar';
import Dot from '../dot/Dot';
import styles from './NotificationBox.module.scss';

export type NotificationBoxProps = {
    type: 'create' | 'update' | 'delete';
    isNew?: boolean;
    children?: React.ReactNode;
    closeToast?: () => void;
    toastProps?: Record<string, unknown>;
} & HTMLAttributes<HTMLDivElement>;

const colors = {
    delete: '#ef343f',
    create: '#6fcebe',
    update: '#ffd45b',
} as const;

const NotificationBox = ({
    type,
    isNew = false,
    children,
    // Those are passed to this component by the react-toastify library, we do not want them passed to the html node
    closeToast,
    onClick,
    toastProps: __,
    ...props
}: NotificationBoxProps) => (
    <div
        className={styles.container}
        role="button"
        tabIndex={0}
        onClick={(e) => {
            onClick?.(e);
            closeToast?.();
        }}
        {...props}
    >
        <Bar backgroundColor={colors[type]} />
        <div className={styles.childContainer}>{children}</div>
        {isNew && (
            <Dot
                color="#fd737b"
                margins={false}
                style={{ minHeight: '8px', minWidth: '8px' }}
            />
        )}
    </div>
);

export default memo(NotificationBox);
